import React, { useState } from "react";
import AuthFormFields from "@/components/AuthFormFields";
import { useAuthForm } from "@/hooks/useAuthForm";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { COUNTRIES, CURRENCIES } from "@/constants/locale";

export default function RegisterForm({ onSuccess }) {
  const form = useAuthForm();
  const { register } = useAuth();
  const [country, setCountry] = useState("India");
  const [currency, setCurrency] = useState("INR");

  const submit = (e) => {
    e.preventDefault();
    form.handleSubmit(async ({ email, password, name }) => {
      await register(email, password, name, { country, currency });
      toast.success("Account created. Let's find your idea.");
      onSuccess?.();
    });
  };

  return (
    <>
      <AuthFormFields
        showName
        email={form.email} setEmail={form.setEmail}
        password={form.password} setPassword={form.setPassword}
        name={form.name} setName={form.setName}
        onSubmit={submit}
        submitting={form.submitting}
        submitLabel="Create account →"
        errorMsg={form.errorMsg}
      />
      <div className="mt-4 grid grid-cols-2 gap-3">
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-[color:var(--muted)]">Country</span>
          <select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            className="mt-1 w-full px-3 py-2.5 bg-transparent border border-[color:var(--fg)] focus:outline-none text-sm font-semibold"
          >
            {COUNTRIES.map((c) => (
              <option key={c} value={c} className="bg-[color:var(--bg)] text-[color:var(--fg)]">{c}</option>
            ))}
          </select>
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-[color:var(--muted)]">Currency</span>
          <select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            className="mt-1 w-full px-3 py-2.5 bg-transparent border border-[color:var(--fg)] focus:outline-none text-sm font-semibold"
          >
            {CURRENCIES.map((c) => (
              <option key={c.code} value={c.code} className="bg-[color:var(--bg)] text-[color:var(--fg)]">
                {c.symbol} {c.code}
              </option>
            ))}
          </select>
        </label>
      </div>
    </>
  );
}
